import io from "socket.io-client";

const socket = io.connect("https://tictactoe-5ewy.onrender.com");

export default socket;
